import { FC } from 'react'

import { ISvgClass } from '../interface'

const DashboardIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8672 6.08984C12.793 5.01562 11.418 4.5 10 4.5V10L6.13281 13.8672C8.23828 16.0156 11.7617 16.0156 13.9102 13.8672C16.0586 11.7188 16.0586 8.23828 13.8672 6.08984ZM10 0.804688C4.92969 0.804688 0.847656 4.92969 0.847656 10C0.847656 15.0703 4.92969 19.1523 10 19.1523C15.0703 19.1523 19.1523 15.0703 19.1523 10C19.1523 4.92969 15.0703 0.804688 10 0.804688ZM10 17.3047C5.96094 17.3047 2.65234 14.0391 2.65234 10C2.65234 5.91797 5.96094 2.65234 10 2.65234C14.0391 2.65234 17.3477 5.91797 17.3477 10C17.3477 14.0391 14.0391 17.3047 10 17.3047Z"
        fill="inherit"
      />
    </svg>
  )
}

export default DashboardIcon
